import { render } from "./FeatInfoArticleBox.vue?vue&type=template&id=e9b1311c&scoped=true"
import script from "./FeatInfoArticleBox.vue?vue&type=script&lang=js"
export * from "./FeatInfoArticleBox.vue?vue&type=script&lang=js"

import "./FeatInfoArticleBox.vue?vue&type=style&index=0&id=e9b1311c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e9b1311c"

export default script